import {
  IconCart,
  IconDash,
  IconHome,
  IconJobs,
  IconLogin,
  IconMenu,
  IconPipeline,
  IconSearch,
  IconShop,
  IconStock,
  IconUser,
} from "mobile/components/MobileNavIcons";

/**
 * Bottom navigation is intentionally short; the drawer contains the full app menu.
 *
 * Note: `permissionKey` is checked using `AuthContext.hasPermission` when available.
 * `drive` marks the primary action tab for that surface (visual emphasis).
 */
export const mobileBottomNavItems = [
  {
    key: "home",
    label: "Home",
    icon: IconHome,
    to: "/m",
    public: true,
  },
  {
    key: "catalog",
    label: "Shop",
    icon: IconShop,
    to: "/m/catalog",
    public: true,
    drive: true,
  },
  {
    key: "cart",
    label: "Cart",
    icon: IconCart,
    to: "/m/cart",
    public: true,
  },
  {
    key: "account",
    label: "Account",
    icon: IconUser,
    to: "/m/account",
    public: false,
  },
  {
    key: "dashboard",
    label: "Home",
    icon: IconDash,
    to: "/m/dashboard",
    public: false,
    permissionKey: "dashboard",
  },
  {
    key: "pipeline",
    label: "Pipeline",
    icon: IconPipeline,
    to: "/m/pipeline",
    public: false,
    permissionKey: "pipeline",
  },
  {
    key: "work-orders",
    label: "Jobs",
    icon: IconJobs,
    to: "/m/work-orders",
    public: false,
    permissionKey: "work-orders",
  },
  {
    key: "inventory",
    label: "Stock",
    icon: IconStock,
    to: "/m/inventory",
    public: false,
    permissionKey: "inventory",
  },
  {
    key: "search",
    label: "Search",
    icon: IconSearch,
    to: null,
    public: false,
    drive: true,
  },
  {
    key: "login",
    label: "Sign in",
    icon: IconLogin,
    to: "/m/authentication/sign-in",
    public: true,
    hideWhenAuthed: true,
  },
  {
    key: "menu",
    label: "Menu",
    icon: IconMenu,
    to: null,
    public: true,
  },
];

/** Primary drive key by shell context — the action we want to pull people toward. */
export const CONTEXT_DRIVE = {
  public: "catalog",
  catalog: "catalog",
  cart: "catalog",
  account: "catalog",
  dashboard: "search",
  "work-orders": "search",
  inventory: "search",
  pipeline: "search",
  sales: "search",
  warehouse: "search",
  accounts: "search",
  settings: "search",
};
